import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/layout/ScrollToTop';
import { getMarketingRouteElements, NotFound } from './MarketingRoutes';

const SecureRoutes = lazy(() => import('./SecureRoutes'));

const secureFallback = <div className="min-h-screen bg-surface" aria-busy="true" />;

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {getMarketingRouteElements()}
          <Route
            path="/auth/*"
            element={
              <Suspense fallback={secureFallback}>
                <SecureRoutes area="auth" />
              </Suspense>
            }
          />
          <Route
            path="/app/*"
            element={
              <Suspense fallback={secureFallback}>
                <SecureRoutes area="app" />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
